<template>
  <component :is="componentName" v-bind="{ ...componentAttributes, width, height }" @error="$emit('error')"></component>
</template>

<script>
  import { ThumbnailResource } from '@/api-resources';
  import { THUMBNAIL_SIZE } from '@/config';

  export default {
    name: 'ThumbnailImage',

    props: {
      thumbnail: ThumbnailResource,
      inlineSvg: Boolean,
      width: {
        type: Number,
        default: THUMBNAIL_SIZE,
      },
      height: {
        type: Number,
        default: THUMBNAIL_SIZE,
      },
    },

    computed: {
      componentName() {
        return this.inlineSvg ? 'image' : 'b-img';
      },

      thumbnailId() {
        return this.thumbnail.dicomImageId ?? this.thumbnail.id;
      },

      thumbnailInstanceId() {
        return this.thumbnail.instanceId;
      },

      imageUrl() {
        if (!this.thumbnailId) {
          return this.thumbnail?.imageUrl;
        }

        return this.$route('dicom-thumbnail', {
          dicomImage: this.thumbnailInstanceId,
          width: this.width,
          height: this.height,
          ext: 'jpg',
        });
      },

      componentAttributes() {
        const attributes = {};
        const src = this.inlineSvg ? 'href' : 'src';

        attributes[src] = this.imageUrl;
        attributes['fluid-grow'] = !this.inlineSvg;

        return attributes;
      },
    },
  };
</script>
